import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Sidebar from './Sidebar';
import Header from './Header';
import { toggleSidebar } from '../../redux/slices/uiSlice';
import './Layout.css';

const Layout = ({ children, title }) => {
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector((state) => state.ui);

  return (
    <div className="layout">
      <Sidebar />
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => dispatch(toggleSidebar())} />
      )}
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Header title={title} />
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
